import { Flex } from '@radix-ui/themes';
import { Auction } from '@prisma/client';
import Link from 'next/link';
import { Button } from '../ui/button';

interface Props {
  currentAuction: Auction;
}

const ViewAuctionButton = ({ currentAuction }: Props) => {
  return (
    <Flex justify="end">
      {currentAuction ? (
        <Link href={`/admin/auctions/${currentAuction.id}/settings`}>
          <Button>View Auction</Button>
        </Link>
      ) : (
        <Button disabled>View Auction</Button>
      )}
    </Flex>
  );
};

export default ViewAuctionButton; 